// Remembers where the user was on a recipe list page (selected category +
// scroll position) when they tap into a recipe, so coming back — via the
// page's back link or the browser back button — returns them to the same
// spot instead of the top of "All Recipes".
//
// Stored in sessionStorage (per-tab, cleared when the tab closes). No time
// limit: as long as the tab stays open, coming back to the list — even hours
// later — returns to the same spot. Closing the tab starts fresh.

export const saveListReturnState = (key, state) => {
  try {
    sessionStorage.setItem(
      `listReturn:${key}`,
      JSON.stringify({ ...state, scrollY: window.scrollY, ts: Date.now() })
    );
  } catch { /* storage unavailable — best-effort */ }
};

// Non-destructive read (safe under React StrictMode double-mounts).
// Call clearListReturnState once the restore has actually been applied.
export const readListReturnState = (key) => {
  try {
    const raw = sessionStorage.getItem(`listReturn:${key}`);
    if (!raw) return null;
    const state = JSON.parse(raw);
    if (!state || !state.ts) {
      sessionStorage.removeItem(`listReturn:${key}`);
      return null;
    }
    return state;
  } catch {
    return null;
  }
};

export const clearListReturnState = (key) => {
  try {
    sessionStorage.removeItem(`listReturn:${key}`);
  } catch { /* best-effort */ }
};
